import gsap from 'gsap';

import { BaseBonusBoardDrawer } from './BaseBonusBoardDrawer';
import { gameConfig } from '../../../core/configs';
import { bonusBoardResourceNames, bonusBoardResources } from '../../../core/gameConstants';
import { BONUS_AMOUNT_MULTIPLE, FONT_BALOO_NAME } from '../../../core/constats';
import {
  HAS_BUY_BONUS,
  SPIN_AMOUNT,
  SPIN_AMOUNT_ACTIVE,
  WHEEL_ROTATION_STATE,
} from '../../../stateManagment/gameState';
import { amountFormatter } from '../../../core/helpers/amountFormatter';
import { partnerService } from '../../../services/helperService/PartnerService';
import { popupHelper } from '../../../services/helperService/PopupHelper';
import { buyBonusButtonHelper } from '../../../services/helperService/BuyBonusButtonHelper';
import { random } from '../../../core/helpers/random';
import { soundService } from '../../../services/helperService/PixiSoundService';
import { debounce } from '../../../core/helpers/debounce';

export class BonusBoardDesktopDrawer extends BaseBonusBoardDrawer {
  constructor() {
    super();
    this.container = null;
    this.loader = this.createLoader();
    this.resources = null;
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(bonusBoardResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  setupPosition() {
    const { x, y } = gameConfig.backgroundAnimationPosition;
    this.setPosition(this.container, { x, y: y + 8 });
  }

  setBonusBoard() {
    const animations = ['no_shine', 'shine'];
    const board = this.createSpine(this.resources[bonusBoardResourceNames.board]);
    board.state.setAnimation(0, 'no_shine', false);

    board.state.addListener({
      complete: function (entry) {
        board.state.setAnimation(0, animations[random(0, 2)] || 'no_shine', false);
      },
    });

    board.state.timeScale = 0.7;
    const button = this.getBonusButton();
    const slot = this.getSlot({ texture: board, name: 'button' });
    this.setupButtonMode(slot);
    this.registerClick(slot, debounce((event) => {
      event.stopPropagation();
      soundService.playSingleClick();
      if (buyBonusButtonHelper.state && !WHEEL_ROTATION_STATE.getValue()) {
        gsap.to(slot, { duration: .1, pixi: { scale: .9 } });
        gsap.to(slot, { delay: .1, duration: .2, pixi: { scale: 1 } });
        popupHelper.setBuyBonusPopupState(true);
      }
    }, 250, true));
    slot.children[0].addChild(button);
    this.container.addChild(board);
  }

  getBonusButton() {
    const buttonContainer = this.createContainer('buttonContainer');

    const amountText = new this.PIXI.Text('', {
      fontFamily: FONT_BALOO_NAME,
      fontSize: 25,
      align: 'center',
      fontWeight: 900,
      fill: 0xFFFFFF,
      dropShadowColor: 0x296d1e,
      dropShadowAlpha: .5,
      dropShadowBlur: 1,
      dropShadowDistance: 4,
      dropShadow: true,
    });

    this.addSubscriber(SPIN_AMOUNT_ACTIVE.subscribe((index) => {
      amountText.text = `${amountFormatter.format(
        SPIN_AMOUNT.getValue()[index] * BONUS_AMOUNT_MULTIPLE)} ${partnerService.displayCurrency}`;
      if (amountText.text.length >= 13) {
        amountText.style.fontSize = 24;
      }

      if (amountText.text.length >= 14) {
        amountText.style.fontSize = 22;
      }

      if (amountText.text.length < 13) {
        amountText.style.fontSize = 25;
      }
    }, true));

    amountText.anchor.set(.5);

    buttonContainer.addChild(
      amountText,
    );
    this.addSubscriber(HAS_BUY_BONUS.subscribe(state => {
      this.container.visible = state;
    }, true));

    return buttonContainer;
  }

  async onLoad() {
    return this.loadResource();
  }

  async executeMainScene(root) {
    await this.loadResource();
    this.setupPosition();
    this.setBonusBoard();
  }
}
